/**
 * getNextRoundUpValue
 * Rounds up to the next limit value number
 * @param {Number} value Number to round up
 */
function getNextRoundUpValue(value) {
  // Get the first number and add 1
  if (!value) {
    return null;
  }

  let numberToCheck = value;
  const isDecimal = value.toString(10).indexOf('.') > 0;
  const firstNumber = parseInt(value.toString(10).slice(0, 1), 10);
  if (isDecimal && firstNumber === 0) {
    const decimalNumber = value.toString(10).split('.');
    numberToCheck = parseInt(decimalNumber[1].toString(10).slice(0, 1), 10);
  }

  let result = parseInt(numberToCheck.toString(10).slice(0, 1), 10) + 1;
  const integerPart = parseInt(numberToCheck, 10);
  const additionalZero = integerPart.toString(10).length;
  const additionalTotal = result > 9 ? additionalZero + 1 : additionalZero;
  // Add 0's at the end
  result = result.toString().padEnd(additionalTotal, '0');
  if (isDecimal && firstNumber === 0) {
    result = `0.${result}`;
  }

  return isDecimal && firstNumber === 0 ? parseFloat(result) : parseInt(result, 10);
}

export default getNextRoundUpValue;
